import type {
  SidebarThemeId,
  SidebarThemeOption,
  SidebarThemePreview,
} from "./types";

const defaultPreview: SidebarThemePreview = {
  dotColor: "#5B21F4",
};

const blackPreview: SidebarThemePreview = {
  dotColor: "#0A0A0A",
  dotBorder: "1px solid rgba(255,255,255,0.2)",
};

const whitePreview: SidebarThemePreview = {
  dotColor: "#FFFFFF",
  dotBorder: "1px solid rgba(0,0,0,0.12)",
};

export const SIDEBAR_THEME_OPTIONS: SidebarThemeOption[] = [
  { id: "default", labelKey: "default", preview: defaultPreview },
  { id: "black", labelKey: "black", preview: blackPreview },
  { id: "white", labelKey: "white", preview: whitePreview },
];

export const DEFAULT_SIDEBAR_THEME: SidebarThemeId = "default";

export const SIDEBAR_THEME_STORAGE_KEY = "knoot_sidebar_theme";

const SIDEBAR_THEME_IDS = new Set<SidebarThemeId>(
  SIDEBAR_THEME_OPTIONS.map((option) => option.id),
);

export function isSidebarThemeId(value: string): value is SidebarThemeId {
  return SIDEBAR_THEME_IDS.has(value as SidebarThemeId);
}
